import * as React from 'react';
import styled, {css} from 'styled-components'
import {ConstBreakPoint, ConstColor, ConstFontStyle, ConstMargin} from "../../../../config/styles_const/styles_const";

interface IProps
    extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLHeadingElement>, HTMLHeadingElement> {
    icon?: string;
    defaultMargin?: boolean;
}

const HeadlineLargeDefault: React.SFC<IProps> = (props) => {

    const {icon, defaultMargin, children, ...HeadlineProps } = props;

    return(<h1 {...HeadlineProps}>{children}</h1>);

};

const HeadlineLarge = styled(HeadlineLargeDefault)`
    color: ${ConstColor.Base};
    font-style: normal;
    font-weight: ${ConstFontStyle.SpHeadlineLarge.fontWeight};
    font-size: ${ConstFontStyle.SpHeadlineLarge.fontSize};
    line-height: ${ConstFontStyle.SpHeadlineLarge.lineHeight};
    @media screen and (min-width: ${ConstBreakPoint.Default}) {
        font-weight: ${ConstFontStyle.HeadlineLarge.fontWeight};
        font-size: ${ConstFontStyle.HeadlineLarge.fontSize};
        line-height: ${ConstFontStyle.HeadlineLarge.lineHeight};
    }
    
    ${props => props.defaultMargin && css`
        margin-bottom: ${ConstMargin.SpHeadlineLargeBottom};
        @media screen and (min-width: ${ConstBreakPoint.Default}) {
            margin-bottom: ${ConstMargin.HeadlineLargeBottom};
        }
    `}
    ${props => props.icon && css`
        ::before {
            margin-right: ${ConstMargin.HeadlineIconRight};
            content: ${props.icon};
            font-family: "Font Awesome 5 Free";
            font-weight: 900;
        }
    `}
`;

export default HeadlineLarge;



// WEBPACK FOOTER //
// ./src/presentation/common/atom/text/headline_large.tsx